
    import '/Users/jilin/projects/antd/rc-dialog/docs/demo/pure.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-demo-pure-demo-pure"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/jilin/projects/antd/rc-dialog/docs/demo/pure.md?type=demo')
};